import {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {TextField} from '@material-ui/core';

import {Icon} from 'front-onceforall-core';
import {isEmpty} from 'front-onceforall-core/dist/utils/strings';

import {MAX_QUERY_LENGTH} from '../../utils/constant';
import CountrySelector from '../countrySelector';
import OrganisationItem from '../organisation/OrganisationItem';
import ListSearchBar from '../listSearchBar';

function OrganisationInvitationView(props) {
  const listRef = useRef(null);

  function handleListScroll({target}) {
    // When user has reached the bottom of the list, call function to load more results
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      props.onLoadMoreResults();
    }
  }

  useEffect(() => {
    // Scroll back to top of list if search or post code is changing
    // to avoid triggering the load more results after a new search
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
  }, [props.search, props.postCode]);

  return (
    <div>
      {props.title &&
        <h2 className="m-0">
          <Translate
            data-id="title"
            value={`${props.title}.add.title`}
          />
        </h2>
      }
      {props.notice &&
        <div
          data-id="notice"
          className="mt-4"
        >
          {props.notice}
        </div>
      }

      <div className="mt-5">
        <>
          <div className="row mb-3">
            <div className="col-md-6">
              <CountrySelector
                data-id="country-selector"
                value={props.country}
                onChange={props.onChangeCountry}
              />
            </div>
            <div className="col-md-6">
              <TextField
                data-id="post-code-field"
                value={props.postCode}
                label={<Translate value="address.postCode"/>}
                onChange={props.onChangePostCode}
              />
            </div>
          </div>
          <ListSearchBar
            onSearch={props.onSearch}
            isTyping={() => {}}
            defaultValue={props.search}
            label={<Translate value="organisation.search.inputLabel"/>}
            placeholder={props.idNumbersLabel}
            maxQueryLength={MAX_QUERY_LENGTH}
          />
          <div>
            <div
              className="mt-3"
              style={{
                paddingRight: 10,
                position: 'relative',
                maxHeight: 500,
                overflowY: 'scroll'
              }}
              onScroll={handleListScroll}
              ref={listRef}
            >
              {props.loading && <div className="loading-overlay"/>}
              {props.organisations.map(organisation => (
                <div
                  data-id={`organisation-${organisation.organisationId}`}
                  key={organisation.organisationId}
                  onClick={() => props.onSelect(organisation)}
                >
                  <OrganisationItem organisation={organisation}/>
                </div>
              ))}
            </div>
            {props.errorText &&
              <div className="box flex-container rejected error mt-4">
                <Icon
                  icon="rounded-cross"
                  size={20}
                />
                <Translate value={props.errorText}/>
              </div>
            }
            {!isEmpty(props.search) &&
              <div className="box info flex-container space-between mt-4">
                <div>
                  <h3>
                    <Translate value="organisation.search.invite.title"/>
                  </h3>
                  <Translate value="organisation.search.invite.text"/>
                </div>
                <button
                  className="small primary"
                  onClick={props.onInviteExternalOrganisation}
                >
                  <Translate value="organisation.search.invite.action"/>
                </button>
              </div>
            }
          </div>
        </>
      </div>

      {props.onCancel &&
        <div className="mt-5 flex-container space-between">
          <button
            data-id="cancel"
            type="button"
            className="large secondary flex-container no-wrap"
            onClick={props.onCancel}
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
        </div>
      }
    </div>
  );
}

OrganisationInvitationView.propTypes = {
  organisations: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  postCode: PropTypes.string.isRequired,
  onChangePostCode: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  onChangeCountry: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  notice: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onCancel: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  onInviteExternalOrganisation: PropTypes.func.isRequired,
  idNumbersLabel: PropTypes.string,
  onLoadMoreResults: PropTypes.func.isRequired
};

export default OrganisationInvitationView;
